import { styled } from '@mui/material/styles';
import { globalZindex } from 'core/common/constants';
import { Container } from 'core/common/ui/ui-kit';
import { applicationSidePaddingPx, contentMaxWidthPx } from 'core/theme/constants';

export const FooterLayoutStyled = styled('div')<{ isHidden?: boolean }>`
  position: fixed;
  bottom: 0;
  left: 50%;
  z-index: ${globalZindex.content};
  display: ${({ isHidden }) => (isHidden ? 'none' : 'flex')};
  width: 100%;
  max-width: ${contentMaxWidthPx}px;
  padding: ${applicationSidePaddingPx}px;
  background-color: ${({ theme }) => theme.palette.contentBlockBackground.main};
  transform: translateX(-50%);
  visibility: ${({ isHidden }) => (isHidden ? 'hidden' : 'visible')};

  @supports (padding: env(safe-area-inset-bottom)) {
    padding-bottom: calc(env(safe-area-inset-bottom) + ${applicationSidePaddingPx}px);
  }
`;

export const FooterLayoutBodyStyled = styled(Container)`
  width: 100%;
  padding-right: 0;
  padding-left: 0;
`;
